module.exports = __webpack_public_path__ + "img/icn_dragdrop.08c8ec99.svg";